/* KYOTOYS conversion layer V22: fast-buy + full-card navigation + collector motion safeguards. */
(function () {
  // Include the supplied root itself as well as descendants. Shopify product recommendations
  // are injected asynchronously, so initializing only descendants can miss the card root.
  function queryAll(root, selector) {
    var scope = root || document;
    var matches = [];
    if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) matches.push(scope);
    if (scope.querySelectorAll) matches = matches.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
    return matches;
  }

  function initProductCards(root) {
    queryAll(root, '.product-card-wrapper[data-product-card-link]').forEach(function (card) {
      if (card.dataset.cardNavigationReady === 'true') return;
      card.dataset.cardNavigationReady = 'true';
      var url = card.getAttribute('data-product-card-link');
      if (!url) return;
      card.addEventListener('click', function (event) {
        if (event.defaultPrevented) return;
        var interactive = event.target.closest('a,button,input,select,textarea,summary,modal-opener,quick-add-modal,quantity-input,product-form');
        if (interactive) return;
        window.location.href = url;
      });
      card.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && event.target === card) {
          event.preventDefault();
          window.location.href = url;
        }
      });
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'View product: ' + ((card.querySelector('.card__heading') || {}).textContent || '').trim());
    });
  }

  function updateCardVariant(card, swatch) {
    if (!card || !swatch) return;
    var image = swatch.getAttribute('data-variant-image');
    var price = swatch.getAttribute('data-variant-price') || '';
    var comparePrice = swatch.getAttribute('data-variant-compare-price') || '';
    var priceValue = Number(swatch.getAttribute('data-variant-price-value') || 0);
    var compareValue = Number(swatch.getAttribute('data-variant-compare-value') || 0);
    var title = swatch.getAttribute('data-variant-title') || '';

    var media = card.querySelector('.card__media');
    var mainImage = media && media.querySelector('img');
    if (mainImage && image) {
      mainImage.src = image;
      mainImage.removeAttribute('srcset');
      mainImage.setAttribute('data-kyoto-selected-variant-image', image);
    }

    var priceWrap = card.querySelector('.card-information .price');
    if (priceWrap) {
      var regular = priceWrap.querySelector('.price__regular .price-item--regular');
      var sale = priceWrap.querySelector('.price__sale .price-item--sale');
      var old = priceWrap.querySelector('.price__sale .price-item--regular');
      var onSale = compareValue > priceValue;
      priceWrap.classList.toggle('price--on-sale', onSale);
      if (onSale) {
        if (sale) sale.textContent = price;
        if (old) old.textContent = comparePrice;
        priceWrap.querySelector('.price__regular')?.setAttribute('hidden', 'hidden');
        priceWrap.querySelector('.price__sale')?.removeAttribute('hidden');
      } else {
        if (regular) regular.textContent = price;
        priceWrap.querySelector('.price__regular')?.removeAttribute('hidden');
        priceWrap.querySelector('.price__sale')?.setAttribute('hidden', 'hidden');
      }
    }

    var input = card.querySelector('.kyoto-card-add-to-cart input[name="id"], .kyoto-quick-buy input[name="id"]');
    if (input) input.value = swatch.getAttribute('data-variant-id') || input.value;

    card.setAttribute('data-selected-variant-id', swatch.getAttribute('data-variant-id') || '');
    card.setAttribute('data-selected-variant-title', title);
  }

  function initSwatches(root) {
    queryAll(root, '.product-card-wrapper').forEach(function(card){
      if (card.dataset.swatchReady === 'true') return;
      var swatches = card.querySelectorAll('.color-swatch[data-variant-id]');
      var input = card.querySelector('.kyoto-card-add-to-cart input[name="id"], .kyoto-quick-buy input[name="id"]');
      if (!swatches.length || !input) return;
      card.dataset.swatchReady = 'true';

      var initialId = String(input.value || '');
      var initial = Array.prototype.find.call(swatches, function(s){
        return String(s.getAttribute('data-variant-id')) === initialId;
      }) || swatches[0];

      swatches.forEach(function(swatch){
        swatch.setAttribute('aria-pressed', 'false');
        swatch.addEventListener('click', function(event){
          event.preventDefault();
          event.stopPropagation();
          var id = swatch.getAttribute('data-variant-id');
          if (!id) return;
          input.value = id;
          swatches.forEach(function(s){
            s.classList.remove('is-selected');
            s.setAttribute('aria-pressed', 'false');
          });
          swatch.classList.add('is-selected');
          swatch.setAttribute('aria-pressed', 'true');
          updateCardVariant(card, swatch);
        });
      });

      if (initial) {
        initial.classList.add('is-selected');
        initial.setAttribute('aria-pressed', 'true');
        updateCardVariant(card, initial);
      }
    });
  }

  function closeVariantSheet() {
    var sheet = document.querySelector('.kyoto-variant-sheet');
    if (!sheet) return;
    sheet.classList.remove('is-open');
    setTimeout(function(){ sheet.remove(); }, 180);
    document.body.classList.remove('kyoto-variant-lock');
  }

  function quickAddVariant(form, variantId, triggerButton, sheet) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!variantId) return Promise.reject(new Error('Please select a valid variant.'));

    var buyButton = sheet && sheet.querySelector('[data-kyoto-sheet-buy]');
    if (buyButton) {
      buyButton.disabled = true;
      buyButton.classList.add('is-loading');
      buyButton.innerHTML = 'ADDING TO CART <span class="kyoto-buy-spinner" aria-hidden="true"></span>';
    }

    var formData = new FormData(form);
    formData.set('id', String(variantId));
    formData.set('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function(section){ return section.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
    }
    if (cart && cart.setActiveElement) cart.setActiveElement(triggerButton || document.activeElement);

    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: formData
    })
      .then(function(response){ return response.json(); })
      .then(function(response){
        if (response.status) {
          throw new Error(response.description || response.message || 'This variant could not be added to cart.');
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        return response;
      });
  }

  function openVariantSheet(button) {
    var card = button.closest('.product-card-wrapper');
    var dataNode = card && card.querySelector('.kyoto-variant-data');
    var form = card && card.querySelector('.kyoto-card-add-to-cart form[action$=\"/cart/add\"]');
    if (!form || !dataNode) return;
    var variants;
    try { variants = JSON.parse(dataNode.textContent); } catch(e) { return; }
    if (!variants.length || !form) return;

    var existing = document.querySelector('.kyoto-variant-sheet');
    if (existing) existing.remove();
    var currentId = form.querySelector('input[name="id"]')?.value;
    var firstAvailable = variants.find(function(v){ return v.available && String(v.id) === String(currentId); }) || variants.find(function(v){ return v.available; });
    if (!firstAvailable) return;

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>\"']/g, function(ch) {
        return {'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;',"'":'&#39;'}[ch];
      });
    }

    var productImage = (card.querySelector('.card__media img') || {}).src || '';
    var html = '<div class="kyoto-variant-sheet" role="dialog" aria-modal="true" aria-label="Quick buy options">' +
      '<div class="kyoto-variant-sheet__backdrop" data-kyoto-sheet-close></div>' +
      '<div class="kyoto-variant-sheet__panel">' +
      '<button type="button" class="kyoto-variant-sheet__close" aria-label="Close" data-kyoto-sheet-close>×</button>' +
      '<div class="kyoto-variant-sheet__product-head">' +
      '<div class="kyoto-variant-sheet__product-image"><img src="' + escapeHtml(productImage) + '" alt="" loading="eager"></div>' +
      '<div><span class="kyoto-variant-sheet__eyebrow">QUICK BUY</span>' +
      '<h3>' + escapeHtml(((card.querySelector('.card__heading') || {}).textContent || 'Choose your variant').trim()) + '</h3>' +
      '<p>Select the exact variant, then buy without leaving the collection.</p></div></div>' +
      '<div class="kyoto-variant-sheet__options">';
    variants.forEach(function(v){
      var image = v.image || productImage;
      html += '<button type="button" class="kyoto-variant-option' + (v.available ? '' : ' is-disabled') + (String(v.id) === String(firstAvailable.id) ? ' is-selected' : '') + '" data-variant-id="' + escapeHtml(v.id) + '" data-variant-image="' + escapeHtml(image) + '" ' + (v.available ? '' : 'disabled') + '>' +
        '<span class="kyoto-variant-option__image"><img src="' + escapeHtml(image) + '" alt="" loading="lazy"></span>' +
        '<span class="kyoto-variant-option__title">' + escapeHtml(v.title) + '</span><b>' + escapeHtml(v.price) + '</b></button>';
    });
    html += '</div><button type="button" class="kyoto-variant-sheet__buy" data-kyoto-sheet-buy>BUY NOW <span>→</span></button>' +
      '<small>⚡ Added to cart instantly • secure checkout • COD available</small>' +
      '<p class="kyoto-variant-sheet__error" role="alert" hidden></p></div></div>';
    document.body.insertAdjacentHTML('beforeend', html);
    var sheet = document.querySelector('.kyoto-variant-sheet');
    var input = form.querySelector('input[name="id"]');
    var selected = String(firstAvailable.id);
    if (input) input.value = selected;
    document.body.classList.add('kyoto-variant-lock');
    requestAnimationFrame(function(){ sheet.classList.add('is-open'); });

    sheet.querySelectorAll('.kyoto-variant-option:not(.is-disabled)').forEach(function(option){
      option.addEventListener('click', function(){
        selected = option.getAttribute('data-variant-id');
        if (input) input.value = selected;
        sheet.querySelectorAll('.kyoto-variant-option').forEach(function(o){ o.classList.remove('is-selected'); });
        option.classList.add('is-selected');
        var preview = sheet.querySelector('.kyoto-variant-sheet__product-image img');
        var nextImage = option.getAttribute('data-variant-image');
        if (preview && nextImage) preview.src = nextImage;
      });
    });
    sheet.querySelectorAll('[data-kyoto-sheet-close]').forEach(function(el){ el.addEventListener('click', closeVariantSheet); });
    sheet.querySelector('[data-kyoto-sheet-buy]').addEventListener('click', function(){
      if (input) input.value = selected;
      var errorBox = sheet.querySelector('.kyoto-variant-sheet__error');
      quickAddVariant(form, selected, button, sheet)
        .then(function(){ closeVariantSheet(); })
        .catch(function(error){
          var buyButton = sheet.querySelector('[data-kyoto-sheet-buy]');
          if (buyButton) {
            buyButton.disabled = false;
            buyButton.classList.remove('is-loading');
            buyButton.innerHTML = 'BUY NOW <span>→</span>';
          }
          if (errorBox) {
            errorBox.textContent = error.message || 'Please try again.';
            errorBox.hidden = false;
          }
        });
    });
  }

  function initDemoRatings(root) {
    var scope = root || document;
    var values = ['4.7', '4.8', '4.9'];
    scope.querySelectorAll('.kyoto-rating-display--demo .kyoto-rating-value--demo').forEach(function(el){
      var value = values[Math.floor(Math.random() * values.length)];
      el.textContent = value;
      var wrapper = el.closest('.kyoto-rating-display--demo');
      if (wrapper) wrapper.setAttribute('aria-label', 'Demo rating ' + value + ' out of 5');
    });
  }

  function initDirectQuickBuy(root) {
    queryAll(root, '.kyoto-quick-buy form').forEach(function(form){
      if (form.dataset.kyotoDirectReady === 'true') return;
      var button = form.querySelector('[data-kyoto-direct-buy]:not([data-kyoto-variant-picker])');
      var input = form.querySelector('input[name="id"]');
      if (!button || !input) return;
      form.dataset.kyotoDirectReady = 'true';
      form.addEventListener('submit', function(event){
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.disabled) return;
        button.disabled = true;
        button.classList.add('is-loading');
        var original = button.querySelector('span');
        if (original) original.textContent = 'ADDING...';
        quickAddVariant(form, input.value, button, null)
          .then(function(){
            button.disabled = false;
            button.classList.remove('is-loading');
            if (original) original.textContent = 'ADD TO CART';
          })
          .catch(function(error){
            button.disabled = false;
            button.classList.remove('is-loading');
            if (original) original.textContent = 'ADD TO CART';
            window.dispatchEvent(new CustomEvent('kyoto:quickbuy:error', {detail:{message:error.message || 'Please try again.'}}));
          });
      }, true);
    });
  }

  function initVariantPickers(root) {
    queryAll(root, '[data-kyoto-variant-picker]').forEach(function(button){
      if (button.dataset.variantPickerReady === 'true') return;
      button.dataset.variantPickerReady = 'true';
      button.addEventListener('click', function(event){
        event.preventDefault();
        openVariantSheet(button);
      });
    });
  }

  function init(root) {
    initProductCards(root);
    initDemoRatings(root);
    initSwatches(root);
    initDirectQuickBuy(root);
    initVariantPickers(root);
  }

  function start() {
    init(document);

    // Shopify's product-recommendations element fetches its markup after DOMContentLoaded.
    // Watch newly inserted cards so product links, color swatches, and variant popups behave
    // exactly like the already-rendered collection cards.
    if (window.MutationObserver && document.body) {
      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) {
            if (node && node.nodeType === 1) init(node);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('product-recommendations:loaded', function (event) { init(event.target || document); });
  document.addEventListener('shopify:product-recommendations:load', function (event) { init(event.target || document); });
})();
